var map = {
	"./10C.png": 302,
	"./10D.png": 9181,
	"./10H.png": 8951,
	"./10S.png": 3646,
	"./2C.png": 9861,
	"./2D.png": 846,
	"./2H.png": 3626,
	"./2S.png": 1092,
	"./3C.png": 6433,
	"./3D.png": 8316,
	"./3H.png": 8985,
	"./3S.png": 3338,
	"./4C.png": 6463,
	"./4D.png": 5864,
	"./4H.png": 1466,
	"./4S.png": 4930,
	"./5C.png": 3261,
	"./5D.png": 4447,
	"./5H.png": 2433,
	"./5S.png": 9220,
	"./6C.png": 1797,
	"./6D.png": 8912,
	"./6H.png": 6594,
	"./6S.png": 1998,
	"./7C.png": 3499,
	"./7D.png": 9369,
	"./7H.png": 3408,
	"./7S.png": 5345,
	"./8C.png": 770,
	"./8D.png": 485,
	"./8H.png": 6567,
	"./8S.png": 8786,
	"./9C.png": 3310,
	"./9D.png": 58,
	"./9H.png": 8734,
	"./9S.png": 5115,
	"./AC.png": 1335,
	"./AD.png": 6259,
	"./AH.png": 3800,
	"./AS.png": 2057,
	"./JC.png": 1800,
	"./JD.png": 6879,
	"./JH.png": 3803,
	"./JS.png": 9788,
	"./KC.png": 2878,
	"./KD.png": 6108,
	"./KH.png": 4999,
	"./KS.png": 9484,
	"./QC.png": 59,
	"./QD.png": 8705,
	"./QH.png": 9574,
	"./QS.png": 6580,
	"./card_back.png": 4287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3190;